import styled from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme } from "../theme/toyotaTheme";
import { IconWrapper } from "../globals/IconWrapper";
import { bodyStyle, headerBodyStyle, type TextStyleType } from "../globals/Type";

const BUTTON_HEIGHT = 52;
const WIDTH_LIST = 350;
const HEIGHT_LIST = 360;
const BORDER_RADIUS = 4;
const COLOR = theme.colors.grey2;

export const Wrapper = styled.div<{ show: boolean }>`
    display: flex;
    position: relative;
    flex: 1;
    width: 100%;
    max-width: 100%;
    border-radius: ${BORDER_RADIUS}px;
`;

export const Button = styled.button<TextStyleType>`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    max-width: 100%;
    max-height: ${BUTTON_HEIGHT}px;
    padding: ${theme.space[2]}px 0;
    text-align: start;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
    ${bodyStyle};

    ${IconWrapper} {
        margin-left: ${theme.space[2]}px;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: 0;
            margin-right: ${theme.space[2]}px;
        }
    }
`;

export const ComboList = styled.div<{ show: boolean }>`
    display: ${({ show }) => (show ? "block" : "none")};
    position: absolute;
    top: calc(100% + 5px); /* Added 5px to show the box-shadow at the top */
    right: 0;
    width: 100%;
    max-width: 100%;
    max-height: ${HEIGHT_LIST}px;
    background-color: ${theme.colors.primaryWhite};
    overflow-y: hidden;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    z-index: 1;
    @media ${getBreakpoint("up", "md")} {
        max-width: ${WIDTH_LIST}px;
    }

    html[dir="rtl"] & {
        left: 0;
        right: auto;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    text-transform: uppercase;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${theme.colors.grey2};
`;

export const Box = styled.div`
    position: sticky;
    top: 0;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};
`;

export const Input = styled.input`
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    background-color: ${theme.colors.primaryWhite};
    border: 0;
`;

export const List = styled.div`
    max-height: calc(${HEIGHT_LIST}px - 60px);
    overflow-y: auto;
    padding: 0 ${theme.space[3]}px;
`;

export const ListItem = styled.a`
    display: block;
    padding: ${theme.space[2]}px 0;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${COLOR};
    cursor: pointer;
    ${headerBodyStyle};

    &:hover {
        text-decoration: none;
    }

    &:last-child {
        margin-bottom: ${theme.space[1]}px;
        border-bottom: 0;
    }
`;
